import React from 'react'
import type { VerticalNavItemType } from './VerticalNavItem'
import { VerticalNavItem } from './VerticalNavItem'
type Props = {
  items: VerticalNavItemType[]
}
/**
 * A vertical navigation component that renders a list of navigation items
 * @param items - Array of navigation item objects to display
 * @returns A nav element containing the rendered navigation items
 */
export const VerticalNav = ({ items }: Props): React.ReactElement<'nav'> => {
  return (
    <nav>
      {items.filter(Boolean).map((item: VerticalNavItemType, index: number) => (
        <VerticalNavItem {...item} key={index} />
      ))}
    </nav>
  )
}
